import React from 'react'
import { Provider as ConfigProvider } from './config'
export { useConfigStore } from './config'

const providers = [ConfigProvider]
const Provider = (props) => 
  providers.reduceRight((children, Parent) => <Parent>{ children }</Parent>, props.children)
export default Provider